const TokenKey = 'admin-token'

export function getToken() {
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token)
}

export  function removeToken() {
  return sessionStorage.removeItem(TokenKey)
}
export  function   setBalance(VAL) {
  return sessionStorage.setItem('balance',VAL)
}
export function getBalance() {
  return sessionStorage.getItem('balance')
}
export  function   setPassword(VAL) {
  return sessionStorage.setItem('SDD',VAL)
}
export function getPassword() {
  return sessionStorage.getItem('SDD')
}
export function fBrowserRedirect() {
  let my_equipment;
  var ua = navigator.userAgent.toLowerCase();
  var Android = String(ua.match(/android/i)) == "android";
  var iPad = String(ua.match(/ipad/i)) == "ipad";
  var iPhone = String(ua.match(/iphone/i)) == "iphone";
  if(Android || iPhone) {
    //Android 和 iPhone
    //console.log('Android 和 iPhone');
    my_equipment = 2;
  } else if(iPad) {
    //iPad
    //console.log('iPad');
    my_equipment = 1;
  } else {
    //pc
    //console.log('pc');
    my_equipment = 0;
  }
  return  my_equipment
}
